import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const InfoRadioButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
